export default function setCarousel() {
  const productsCarousel = document.querySelectorAll('[data-products-carousel]');

  productsCarousel.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    if (carousel) {
      new Swiper(carousel, {
        slidesPerView: 2,
        spaceBetween: 16,
        watchOverflow: true,
        speed: 1000,
        //lazy load
        preloadImages: false,
        lazy: {
          checkInView: true,
          loadPrevNext: false,
          loadOnTransitionStart: true,
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
    }
  });
}
